const styles = theme => ({
  imageContent: {
    width: '100%',
  },
  videoLoadingImg: {
    width: '60%',
    margin: '0 auto',
  },
  addIcon: {
    color: 'white',
  },
  folderIcon: {
    fontSize: 178,
    color: '#00adf5',
  },
  titleBar: {
    padding: '4px',
    cursor: 'pointer',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    /*  background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 50%, rgba(0,0,0,0) 100%)', */
  },
  input: {
    padding: theme.spacing(1),
    marginTop: -50,
    marginLeft: 15,
    width: 150,
    fontSize: 13,
  },
  blur: {
    border: '1px solid transparent',
    backgroundColor: 'transparent',
  },
  endAdornmentIcon: {
    color: '#757575',
    fontSize: 16,
  },
  deleteButton: {
    position: 'absolute',
    top: 10,
    left: 10,
  },
  folderIconHolder: {
    overflow: 'hidden',
    width: '100%',
    cursor: 'pointer',
  },
  selected: {
    backgroundColor: 'green',
  },
  chip: {
    fontSize: 9,
    marginBottom: 10,
    marginTop: 12,
    marginRight: 4,
  },
  titleWrapActionPosRight: {
    position: 'absolute',
    bottom: 34,
    right: 10,
  },
  title: {
    fontSize: 12,
    color: '#002E47',
  },
  subtitleAdditional: {
    fontSize: 12,
  },
  imageViewContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    height: '120px',
    cursor: 'pointer',
  },
  bordersHolder: {
    background: 'transparent',
    //height: '',
    //border: '1px solid #f7f7f7',
    overflow: 'hidden',
    minWidth: '213px',
    width: '213px',
    flexDirection: 'column',
    margin: '4px',
    borderRadius: 8,
    '&:hover': {
      outline: '1px solid #015ffb',
    },
  },
  processing: {
    overflow: 'hidden',
    width: '100%',
    backgroundImage: `url('/assets/transcoding.gif')`,
    backgroundSize: 'cover',
    backgroundColor: '#282828',
    textAlign: 'center',
    color: 'wheat',
    minWidth: '213px',
    height: '120px',
    borderRadius: '8px',
    marginTop: '2px',
  },
})

export default styles
